// Шрифты отдаются с нашего же домена, а не с Google Fonts: у приложения не
// должно быть внешней зависимости в критическом пути отрисовки. Браузер
// скачает только нужные начертания — кириллица и латиница разделены
// unicode-range.
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import '@fontsource-variable/unbounded';

import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Глобальные стили — раньше компонентов: правила с одинаковой
// специфичностью побеждает тот, кто объявлен позже, и компонент обязан уметь
// переопределить глобальный :focus-visible или размер иконки.
import '@/shared/styles/global.scss';

import { ErrorBoundary } from '@/app/ErrorBoundary';
import { AppProviders } from '@/app/providers/AppProviders';
import { router } from '@/app/router';
import { getSession, subscribeSession } from '@/shared/auth';
import { installActivationOriginTracker } from '@/shared/lib/activationOrigin';
import { installPromptTracker, preventIOSInputZoom, watchSessionForPush } from '@/shared/pwa';
import { registerServiceWorker } from '@/shared/pwa/register';
import { realtime } from '@/shared/realtime';

// Запоминаем, что человек трогал последним, чтобы окна вырастали из
// кнопки, которая их открыла. Слушатели ставятся один раз на документ.
installActivationOriginTracker();
preventIOSInputZoom();

// Живое соединение с сервером: следит за сеансом само — подключается после
// входа, закрывается при выходе, восстанавливается после обрыва.
realtime.start();

// PWA: worker для кэша оболочки и push; перехват предложения установки;
// после входа подписка на push сверяется с сервером.
registerServiceWorker();
installPromptTracker();
watchSessionForPush(subscribeSession, getSession);

const container = document.getElementById('root');

if (!container) {
  throw new Error('В index.html нет элемента #root — монтировать приложение некуда');
}

createRoot(container).render(
  <StrictMode>
    {/* Граница ошибок снаружи провайдеров: иначе падение при создании клиента
        запросов осталось бы неперехваченным и дало бы пустой экран. */}
    <ErrorBoundary>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ErrorBoundary>
  </StrictMode>,
);
